export enum Month {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export const monthToNumber = (month: Month) => {
  if (month === Month.January) {
    return 1;
  }
  if (month === Month.February) {
    return 2;
  }
  if (month === Month.March) {
    return 3;
  }
  if (month === Month.April) {
    return 4;
  }
  if (month === Month.May) {
    return 5;
  }
  if (month === Month.June) {
    return 6;
  }
  if (month === Month.July) {
    return 7;
  }
  if (month === Month.August) {
    return 8;
  }
  if (month === Month.September) {
    return 9;
  }
  if (month === Month.October) {
    return 10;
  }
  if (month === Month.November) {
    return 11;
  }
  if (month === Month.December) {
    return 12;
  }

  return -1;
};

export const numberToMonth = (numberMonth: number): string => {
  if (numberMonth === 1) {
    return Month.January;
  }
  if (numberMonth === 2) {
    return Month.February;
  }
  if (numberMonth === 3) {
    return Month.March;
  }
  if (numberMonth === 4) {
    return Month.April;
  }
  if (numberMonth === 5) {
    return Month.May;
  }
  if (numberMonth === 6) {
    return Month.June;
  }
  if (numberMonth === 7) {
    return Month.July;
  }
  if (numberMonth === 8) {
    return Month.August;
  }
  if (numberMonth === 9) {
    return Month.September;
  }
  if (numberMonth === 10) {
    return Month.October;
  }
  if (numberMonth === 11) {
    return Month.November;
  }
  if (numberMonth === 12) {
    return Month.December;
  }

  return 'unknown';
};
